// extracted by mini-css-extract-plugin
export default {"container":"FileMedia_container__528H5"};